import { appSettings } from 'config/app.settings';

export enum PageIds {
  'dashboard' = 'dashboard',
  'espn' = 'espn',
}

export function getGuruPageId(subject?: PageIds): string {
  const baseUrl = appSettings.ENV_FEATURE_CONFIG_BASE_URL;

  switch (subject) {
    case PageIds.dashboard:
      return `${baseUrl}/overzicht`;
    case PageIds.espn:
      return `${baseUrl}/espn/voorstel`;
    default:
      return location.href;
  }
}
